import React from 'react';
import {
    TableCell,
    TableRow,
    makeStyles,
    Theme,
    Fade,
    Tooltip,
    Box,
    useTheme,
} from '@material-ui/core';
import { IAIRowOptions } from './types';
import { useTranslation } from 'react-i18next';
import { ChatbotIcon } from 'src/components/ChatbotIcon';
import { Calendar, File, Map } from 'react-feather';

const useStyles = makeStyles((theme: Theme) => ({
    fontWeightMedium: {
        fontWeight: 500,
        backgroundColor: theme.palette.background.paper,
        width: 150,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
}));

export const AIRowOptions = ({ options, loading, ...props }: IAIRowOptions) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();

    const {
        isContacted,
        hasAppointment,
        hasSentDocumentation,
        hasSentLocation,
        isAppointmentConfirmed,
        isDocumentationConfirmed,
        isLocationConfirmed,
    } = options;

    return (
        <TableRow {...props}>
            <TableCell className={classes.fontWeightMedium}>
                {t('Leads.AIContact')}
            </TableCell>
            <Fade in={!loading} timeout={600}>
                <TableCell className={classes.paper}>
                    {isContacted && (
                        <Tooltip title={t(`Leads.AIisContacted`)}>
                            <Box>
                                <ChatbotIcon
                                    fill={theme.palette.success.main}
                                />
                            </Box>
                        </Tooltip>
                    )}
                    {hasAppointment && (
                        <Tooltip title={t(`Leads.AIhasAppointment`)}>
                            <Box>
                                <Calendar
                                    color={
                                        isAppointmentConfirmed
                                            ? theme.palette.success.main
                                            : theme.palette.primary.main
                                    }
                                />
                            </Box>
                        </Tooltip>
                    )}

                    {hasSentDocumentation && (
                        <Tooltip title={t(`Leads.AIhasSentDocumentation`)}>
                            <Box>
                                <File
                                    color={
                                        isDocumentationConfirmed
                                            ? theme.palette.success.main
                                            : theme.palette.primary.main
                                    }
                                />
                            </Box>
                        </Tooltip>
                    )}

                    {hasSentLocation && (
                        <Tooltip title={t(`Leads.AIhasSentLocation`)}>
                            <Box>
                                <Map
                                    color={
                                        isLocationConfirmed
                                            ? theme.palette.success.main
                                            : theme.palette.primary.main
                                    }
                                />
                            </Box>
                        </Tooltip>
                    )}
                </TableCell>
            </Fade>
        </TableRow>
    );
};
